import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[NoStartingZero]',
    standalone: true
})
export class NoStartingZeroDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if(this.el.nativeElement.value===''){
      if(event.key==='0'){
        event.preventDefault();
      }
    }

  }

}
